<template>
  <div class="spe">
    <div class="head-box">
      <swiper ref="mySwiper" :options="swiperOptions" :auto-play="true">
        <swiper-slide v-for="(item,index) in detailData.carousel_image" :key="index">
          <img :src="item" alt />
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <div class="head-box-right">
        <h4>{{detailData.name}}</h4>
        <h4>{{detailData.name_en}}</h4>
        <div class="right-box">
         品牌：<span v-show="detailData.brand !== null"  :style="`background:${detailData.background_color};color:#ffbb00;padding:1px 10px;border-radius:20px`">{{detailData.brand}}</span>
          <br />
          产品编号：{{detailData.goods_code}}
          <br />
          储存条件：{{detailData.storage}}
          <br />
          运输方式：{{detailData.transport}}
          <br />
          保质期：{{detailData.life}}
          <br />
          商品属性：{{detailData.attribute}}
        </div>
      </div>
    </div>
    <div class="table">
      <Table
        :itemList="detailData.sku"
        :brand="detailData.brand"
        :sku_code="detailData.goods_code"
        :name="detailData.name"
      ></Table>
    </div>
    <div class="tab">
      <div class="tab-head">
        <a
          v-for="(item,index) in list"
          :key="index"
          :class="{active:index == currentIndex}"
          @click="toggerIndex(index)"
        >{{item.title}}</a>
      </div>
      <div class="tab-main">
        <div class="tab-main-box" v-if="currentIndex == 0">
          <div>
            <div v-html="detailData.description">{{detailData.description}}</div>
          </div>
        </div>
        <div class="tab-main-box" v-if="currentIndex == 1">
          <div>
            <div class="download" v-for="(item,index) in detailData.instructions" :key="index">
              <div>
                <p>{{item.name}}</p>
              </div>
              <a target="_blank" :href="item.url">点击查看</a>
            </div>
          </div>
        </div>
        <div class="tab-main-box" v-if="currentIndex == 2">
          <div>
            <div class="download" v-for="(item,index) in detailData.msds" :key="index">
              <div>
                <p>{{item.name}}</p>
              </div>
              <a target="_blank" :href="item.url">点击查看</a>
            </div>
          </div>
        </div>
      </div>
      <div>
      <div class="recommend clearfix" v-if="detailData.category_recommend && detailData.category_recommend.length>0">
              <div class="recommend_top clearfix">
                <div style="float: left; padding-left: 12px">相关产品推荐</div>
                <div style="float: right; padding-right: 12px">
                  <div @click="setRollL">
                    <i class="el-icon-caret-left"></i>
                  </div>
                  <div @click="setRollR">
                    <i class="el-icon-caret-right"></i>
                  </div>
                </div>
              </div>
              <div class="recommend_item clearfix">
                <div ref="roll_list" class="recommend_item_list clearfix">
                  <div v-for="(i,v) in  detailData.category_recommend.slice(commend_left,commend_right)" :key="v" class="recommend_items clearfix">
                    <div
                         style="width: 110px; height: 110px; cursor: pointer;  border: 1px solid #DCDFE6">
                      <el-image
                          style="width: 110px; height: 110px;"
                          :src="i.picture"
                          fit="scale-down">
                        <div slot="error" class="image-slot">
                        </div>
                      </el-image>
                    </div>
                    <div style="width: 185px; padding-left: 10px; line-height: 20px">
                      <p style="color: #0589B9; cursor: pointer" @click="goxq(i.goods_code)">
                        {{ i.goods_code }}</p>
                      <p>
                        <span>{{i.name}}</span>
                      </p>
                      <p><span style="margin-right:10px">{{ i.transport_name }}</span>
                      <span>{{ i.storage_name }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./components/table";
import fourBanner from "./components/fourbanner";
export default {
  props: ["id","detailData"],
  components: {
    Table,
    fourBanner
  },
  data() {
    return {
      currentIndex: 0,
      commend_left:0,
      commend_right:3,
      swiperOptions: {
        grabCursor: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      list: [
        { title: "产品描述" },
        { title: "产品说明书" },
        { title: "MSDS/SDS" }
      ],
    };
  },
  methods: {
    toggerIndex(index) {
      this.currentIndex = index;
    },
        // 设置滚动分页开始
    // --左边箭头按钮
    setRollL() {
       if(this.commend_left > 0){
          this.commend_left = this.commend_left - 3
          this.commend_right = this.commend_right - 3
       }else{
          this.commend_left = 0
       }
    },
    // --右边箭头按钮
    setRollR() {
      let length = this.detailData.category_recommend.length
      if(this.commend_right < length){
          this.commend_left = this.commend_left + 3
          this.commend_right = this.commend_right + 3
       }else{
          this.commend_right = length
       }
    },
    goxq(id) {
      let routeUrl = this.$router.resolve({
        path: `/homepage/detail`,
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
  created() {
   
  }
};
</script>

<style lang="less" scoped>
.swiper-button-next,
.swiper-button-prev {
  width: 30px;
  height: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(218, 218, 218, 0.5);
  border-radius: 50%;
}
.swiper-button-next {
  margin-right: 20px;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 18px;
  color: #b3b3b3;
}
.title {
  width: 219px;
  height: 31px;
  font-size: 24px;
  color: #333333;
}
.head-box {
  width: 100%;
  display: flex;
  margin-top: 28px;
  img {
    width: 350px;
    height: 256px;
    border: 1px solid #ccc;
  }
  .head-box-right {
    margin-left: 36px;
    h4 {
      width: 467px;
      font-size: 24px;
      font-weight: 700;
      color: #333333;
    }
    .right-box {
      margin-top: 15px;
      width: 431px;
      font-size: 14px;
      color: #666666;
      line-height: 28px;
    }
  }
}
.table {
  margin-top: 18px;
}
.tab {
  margin-top: 37px;
  margin-bottom: 20px;
  .tab-head {
    width: 876px;
    height: 48px;
    background: #f5f5f5;
    border: 1px solid #dddddd;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    a {
      font-size: 16px;
      color: #333333;
      margin-left: 70px;
      margin-top: 15px;
      text-decoration-line: none;
    }
    .active {
      color: #a52a2a;
    }
  }
  .tab-main {
    width: 876px;
    font-size: 18px;
    text-align: left;
    line-height: 28px;
    .tab-main-box {
      h3 {
        font-size: 18px;
        color: #ffbb00;
        margin: 15px 0px;
      }
      p {
        font-size: 14px;
        line-height: 28px;
      }
      .download {
        width: 876px;
        height: 48px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(211, 211, 211, 0.5);
        display: flex;
        justify-content: space-between;
        padding: 14px 25px;
        margin-top: 20px;
        a {
          font-size: 12px;
          text-decoration: underline;
          color: #003871;
          line-height: 16px;
        }
      }
    }
  }
}


.recommend {
  height: 200px;
  border: 1px solid #dddddd;
  margin-top:20px;
}

.recommend .recommend_top {
  height: 40px;
  line-height:40px;
  background: #f5f5f5;
}

.recommend .recommend_top div {
  color: #a52a2a;
  font-weight: bold;
  font-size: 16px;
  float: left;
  cursor: pointer;
}



.recommend_item_list{
  display: flex;
  margin-top:10px
}


.recommend .recommend_item .recommend_item_list p:nth-child(1):hover {
  text-decoration: underline;
}


.recommend_items{
  width:33.3%;
  display: flex;
  padding-left:1%
}
</style>